export const wordData = {
  title: "Some of Our Projects",
  subtitle:
    // "We, at Truwa, apply neuromarketing and behavioral science to design, digitize and grow your business.",
    "Take a look at our standout projects, where innovation meets exceptional design.",
};
